import React from 'react';
import CampoEditableCheck from '../../UI/campos/CampoEditableCheck.js';
import CampoEditableFechaCampos from '../../UI/campos/CampoEditableFechaCampos.js';
import CampoEditableNumero from '../../UI/campos/CampoEditableNumero.js';
import { CamposToFechaCorta } from '../../funciones/FuncionesFecha.js';
import * as Campos from '../../constantes/Campos.js';
import * as UI from '../../constantes/UI.js';
import styles from './CamposClub.module.css';

const CamposClubFechas = (props) => {
  const club = props.club;
  const editar = props.editar;
  const { esMobile } = UI.useUI();

  const onCampoChange = (campo, valor) => {
    props.onCampoChange(campo, valor);
  };

  let textoDesaparecido = null;
  if (club && club.desaparecido) {
    textoDesaparecido = club.anioDesaparicion ? club.anioDesaparicion : 'Sí';
  }

  return (
    <table className={`${styles.tablaDatos}`}>
      {!editar && club && (
        <tbody>
          <tr>
            <td className={`${styles.tituloColumnas}`}>Fundación</td>
            <td className={`${styles.valorColumnas}`}>
              {club.anioFundacion &&
                CamposToFechaCorta(club.anioFundacion, club.mesFundacion, club.diaFundacion)}
            </td>
            <td className={`${styles.tituloColumnas}`}>
              {club.anioAfiliacion !== null && 'Afiliación'}
            </td>
            <td className={`${styles.valorColumnas}`}>{club.anioAfiliacion}</td>
          </tr>
          {(club.anioDesafiliacion || textoDesaparecido) && (
            <tr>
              <td className={`${styles.tituloColumnas}`}>Desafiliación</td>
              <td className={`${styles.valorColumnas}`}>{club.anioDesafiliacion}</td>
              <td className={`${styles.tituloColumnas}`}>
                {textoDesaparecido !== null && 'Desaparecido'}
              </td>
              <td className={`${styles.valorColumnas}`}>{textoDesaparecido}</td>
            </tr>
          )}
        </tbody>
      )}
      {editar && esMobile && (
        <tbody>
          {/* En mobile: cada campo en su propia fila encolumnada */}
          <tr>
            <td className={`${styles.tituloColumnas}`} style={{ width: '35%' }}>
              Fundación
            </td>
            <td className={`${styles.valorColumnas}`} style={{ width: '65%' }}>
              <CampoEditableFechaCampos
                nombre={Campos.Club.FECHA_FUNDACION}
                anio={club && club.anioFundacion}
                mes={club && club.mesFundacion}
                dia={club && club.diaFundacion}
                editar={editar}
                onChange={onCampoChange}
              />
            </td>
          </tr>
          <tr>
            <td className={`${styles.tituloColumnas}`} style={{ width: '35%' }}>
              Afiliación
            </td>
            <td className={`${styles.valorColumnas}`} style={{ width: '65%' }}>
              <CampoEditableNumero
                nombre={Campos.Club.ANIO_AFILIACION}
                valor={club && club.anioAfiliacion}
                estilo={`${styles.campoAnio}`}
                editar={editar}
                onChange={onCampoChange}
              />
            </td>
          </tr>
          <tr>
            <td className={`${styles.tituloColumnas}`} style={{ width: '35%' }}>
              Desafiliación
            </td>
            <td className={`${styles.valorColumnas}`} style={{ width: '65%' }}>
              <CampoEditableNumero
                nombre={Campos.Club.ANIO_DESAFILIACION}
                valor={club && club.anioDesafiliacion}
                estilo={`${styles.campoAnio}`}
                editar={editar}
                onChange={onCampoChange}
              />
            </td>
          </tr>
          <tr>
            <td className={`${styles.tituloColumnas}`} style={{ width: '35%' }}>
              Desaparecido
            </td>
            <td className={`${styles.valorColumnas}`} style={{ width: '65%' }}>
              <CampoEditableCheck
                nombre={Campos.Club.DESAPARECIDO}
                checked={club && club.desaparecido}
                editar={editar}
                onChange={onCampoChange}
              />
              {club && club.desaparecido && (
                <React.Fragment>
                  <span className={`${styles.anioDesaparicion}`}>Año</span>
                  <CampoEditableNumero
                    nombre={Campos.Club.ANIO_DESAPARICION}
                    valor={club && club.anioDesaparicion}
                    estilo={`${styles.campoAnio}`}
                    editar={editar}
                    onChange={onCampoChange}
                  />
                </React.Fragment>
              )}
            </td>
          </tr>
        </tbody>
      )}
      {editar && !esMobile && (
        <tbody>
          {/* En desktop: 2x2 como antes */}
          <tr>
            <td className={`${styles.tituloColumnas}`}>Fundación</td>
            <td className={`${styles.valorColumnas}`}>
              <CampoEditableFechaCampos
                nombre={Campos.Club.FECHA_FUNDACION}
                anio={club && club.anioFundacion}
                mes={club && club.mesFundacion}
                dia={club && club.diaFundacion}
                editar={editar}
                onChange={onCampoChange}
              />
            </td>
            <td className={`${styles.tituloColumnas}`}>Afiliación</td>
            <td className={`${styles.valorColumnas}`}>
              <CampoEditableNumero
                nombre={Campos.Club.ANIO_AFILIACION}
                valor={club && club.anioAfiliacion}
                estilo={`${styles.campoAnio}`}
                editar={editar}
                onChange={onCampoChange}
              />
            </td>
          </tr>
          <tr>
            <td className={`${styles.tituloColumnas}`}>Desafiliación</td>
            <td className={`${styles.valorColumnas}`}>
              <CampoEditableNumero
                nombre={Campos.Club.ANIO_DESAFILIACION}
                valor={club && club.anioDesafiliacion}
                estilo={`${styles.campoAnio}`}
                editar={editar}
                onChange={onCampoChange}
              />
            </td>
            <td className={`${styles.tituloColumnas}`}>Desaparecido</td>
            <td className={`${styles.valorColumnas}`}>
              <CampoEditableCheck
                nombre={Campos.Club.DESAPARECIDO}
                checked={club && club.desaparecido}
                editar={editar}
                onChange={onCampoChange}
              />
              {club && club.desaparecido && (
                <React.Fragment>
                  <span className={`${styles.anioDesaparicion}`}>Año</span>
                  <CampoEditableNumero
                    nombre={Campos.Club.ANIO_DESAPARICION}
                    valor={club && club.anioDesaparicion}
                    estilo={`${styles.campoAnio}`}
                    editar={editar}
                    onChange={onCampoChange}
                  />
                </React.Fragment>
              )}
            </td>
          </tr>
        </tbody>
      )}
    </table>
  );
};

export default CamposClubFechas;
